
function wcs_email_to_friend_form_ajax(ev, form) {
    ev.preventDefault();
    var params = {};
    var isDMP = $('#nonWCSReq').val();
    params.sku = $('#skuVal').val();
    var emailSRC = $('#emailSRCVal').val();
    params.viewName = emailSRC;
    params.storeId = $('#storeId').val();
    params.catalogId = $('#catalogId').val();
    params.langId = $('#langId').val();
    params.emailAddress = $('#wcs-forEmail').val();
    params.senderEmailAddress = $('#wcs-fromEmail').val();
    var str = stripOutHTMLTag('#wcs-message');
    str = str.replace(/\n/g, '<br />');
    params.message = str;
    params.userName = $('#wcs-userName').val() + " ";
    params.configurationId = form.find('input#configurationIdVal').val();
    var priceValue = $('#priceVal').val();
    var altTextValue = $('#altText').val();
    var $wcs_email_to_friend_form = $('#wcs_email_to_friend_form');

    if (isDMP === 'true') {
        params.priceDK = priceValue;
        params.titleDK = $('#titleDK').val();
        params.nonWCSRequest = true;

        var $remixEdition = $('#remixEdition');
        if ($remixEdition.length) {
            params.remixEdition = $remixEdition.val();
        }

        var $remixName = $('#remixName');
        if ($remixName.length) {
            params.remixName = $remixName.val();
        }

        params.altTextDK = altTextValue;
        params.descDK = $('#descDK').val();
        params.remixURL = $('#remixURL').val();
        params.shareURLDK = $('#shareURLDK').val();
        params.assetPath = $('#assetPath').val();
    } else {
        params.price = priceValue;
        params.productId = $('#productIdVal').val();
        params.catEntryId = form.find('#catEntryIdVal').val();
        params.metaTitle = $('#metaTitleVal').val();

        params.roxLensCatentryId = form.find('#roxLensCatentryId').val();
        params.roxLensPartNumber = form.find('#roxLensPartNumber').val();
        params.roxSet = form.find('#roxSet').val();

        if (emailSRC === 'OrderView') {
            params.catEntryId = $wcs_email_to_friend_form.find('>#catEntryIdVal').val();
        }
        params.name = $('#nameVal').html();

        var $clearancePriceVal = $('#clearancePriceVal');
        if ($clearancePriceVal.length) {
            params.clearancePrice = $clearancePriceVal.val();
        }

        params.partNumber = $('#partNumberVal').val();
        params.altText = altTextValue;
        params.title = $('#title').val();
        params.shareURL = $('#shareURLVal').val();

        var $productPrice = $('.wcs-pdp-product-description').find('#wcs-productprice>span');
        if ($productPrice.length) {
            params.price = $.trim($productPrice.html());
        }
    }

    $.ajax({
        type: "POST",
        url: "SendEmailNotification",
        data: params,
        success: function(result) {
            $wcs_email_to_friend_form.parents('.wcs-quick-buy-lightbox').hide();
            var $wcs_email_to_friend_confirmation = $('#wcs_email_to_friend_confirmation');
            $wcs_email_to_friend_confirmation.show();
            display_center_1($wcs_email_to_friend_confirmation);
            bind_btn_ok();
            append_emailList($('#wcs-forEmail'), $("#wcs_email_list"));
            clear_form($wcs_email_to_friend_form);
        }
    });
}

function contact_us_form_ajax(ev) {
    ev.preventDefault();
    var params = {};
    var currentFormId = $(ev.currentTarget).parents("form").attr("id");
    if (currentFormId !== "help_contact_us_form") {
        var currformid = currentFormId;
        var $currentForm = $('#' + currformid);

        var dropboxval = $currentForm.find("select").val();
        if (dropboxval === undefined) {
            dropboxval = $('#wcs-contact-subject').val();
        }
        params.dropbox = dropboxval;

        var fnameval = $currentForm.find("input[name='"+currformid+"_firstname']").val();
        if (fnameval === undefined) {
            fnameval = $('#wcs-userFName').val();
        }
        params.firstName = fnameval;

        var lnameval = $currentForm.find("input[name='"+currformid+"_lastname']").val();
        if (lnameval === undefined) {
            lnameval = $('#wcs-userLName').val();
        }
        params.lastName = lnameval;

        var emailval = $currentForm.find("input[name='"+currformid+"_email']").val();
        if (emailval === undefined) {
            var userEmailValue = $('#wcs-userEmail').val();
            var fiscalCodeValue = $('#WC_DeliveryInfoForm_fiscal_code').val();
            if (userEmailValue !== "") {
                emailval = userEmailValue;
            } else if (fiscalCodeValue !== "") {
                emailval = fiscalCodeValue;
            }
        }
        params.email = emailval;

        var textmsgval = $currentForm.find("[name='"+currformid+"_textmessage']").val();
        if (textmsgval === undefined) {
            textmsgval = $('#wcs-text-message').val();
        }
        params.textMessage = textmsgval;

        var ordnumberval = $currentForm.find("input[name='"+currformid+"_ordernumber']").val();
        if (ordnumberval === undefined) {
            ordnumberval = $('#wcs_order_number').val();
        }
        params.orderId = ordnumberval;

        var mobileNumberValue = $('#wcs_mobile_number').val();
        if (mobileNumberValue !== "") {
            params.mobile_number = mobileNumberValue;
        } else {
            var customerEmailIdValue = $('#wcs-customerEmailId').val();
            if (customerEmailIdValue !== "") {
                params.email = customerEmailIdValue;
            }
            var customerTelephoneNumberValue = $('#wcs-customerTelephoneNumber').val();
            if (customerTelephoneNumberValue !== "") {
                params.mobile_number = customerTelephoneNumberValue;
            }
        }
        params.isMobileExist = $('#isMobileExist').val();
        params.storeId = $('#storeId').val() || $('#shp_storeId').val();
        params.catalogId = $('#catalogId').val();
        params.langId = $('#langId').val();
        var error = null;
        var $contactusForm = $('.wcs-contactus-form');
        var $contactUsSuccess = $('.wcs-contact-us-success');
        var $helpUsOffline = $('.help-us-offline');
        var $helpUsOfflineSuccess = $('.help-us-offline-success');

        $.ajax({
            type: "POST",
            url: "webapp/wcs/stores/servlet/AjaxSendContactUsEmail",
            data: params,
            success: function(result) {
                var json = $.parseJSON(result);
                $(json).each(function(i, val) {
                    $.each(val, function(k, v) {
                        if (k === "errorMessage") {
                            error = v;
                            $('.wcs-note-red p').html(v);
                            $('.delivery-information-note-red').removeClass('wcs-hidden');
                        }
                    });
                });
                if (error === null) {
                    $contactusForm.addClass('wcs-hide');
                    $contactUsSuccess.removeClass('wcs-hide');
                    $helpUsOffline.addClass('wcs-hide');
                    $helpUsOfflineSuccess.removeClass('wcs-hide');
                    Rayban.analytics.needHelpSuccess();
                    Rayban.analytics.contactUsSuccess();
                } else {
                    Rayban.analytics.needHelpError("Server error");
                }
            },
            error: function(xhr, ajaxOptions, thrownError) {
                $contactusForm.addClass('wcs-hide');
                $contactUsSuccess.removeClass('wcs-hide');
                $helpUsOffline.addClass('wcs-hide');
                $helpUsOfflineSuccess.removeClass('wcs-hide');
                Rayban.analytics.needHelpError("Server error");
                Rayban.analytics.contactUsError("wcs sendMessageFooterForm footerForm submit - ", xhr.responseText);
            }
        });
    }else{
        var currformid = currentFormId;
        var $currentForm = $('#' + currformid);

        var dropboxval = $currentForm.find("select").val();
        if (dropboxval === undefined) {
            dropboxval = $('#wcs-contact-subject').val();
        }
        params.dropbox = dropboxval;

        var fnameval = $currentForm.find("input[name='"+currformid+"_firstname']").val();
        if (fnameval === undefined) {
            fnameval = $('#wcs-userFName').val();
        }
        params.firstName = fnameval;

        var lnameval = $currentForm.find("input[name='"+currformid+"_lastname']").val();
        if (lnameval === undefined) {
            lnameval = $('#wcs-userLName').val();
        }
        params.lastName = lnameval;

        var emailval = $currentForm.find("input[name='"+currformid+"_email']").val();
        if (emailval === undefined) {
            var userEmailValue = $('#wcs-userEmail').val();
            var fiscalCodeValue = $('#WC_DeliveryInfoForm_fiscal_code').val();
            if (userEmailValue !== "") {
                emailval = userEmailValue;
            } else if (fiscalCodeValue !== "") {
                emailval = fiscalCodeValue;
            }
        }
        params.email = emailval;

        var textmsgval = $currentForm.find("[name='"+currformid+"_textmessage']").val();
        if (textmsgval === undefined) {
            textmsgval = $('#wcs-text-message').val();
        }
        params.textMessage = textmsgval;

        var ordnumberval = $currentForm.find("input[name='"+currformid+"_ordernumber']").val();
        if (ordnumberval === undefined) {
            ordnumberval = $('#wcs_order_number').val();
        }
        params.orderId = ordnumberval;

        var mobileNumberValue = $('#wcs_mobile_number').val();
        if (mobileNumberValue !== "") {
            params.mobile_number = mobileNumberValue;
        } else {
            var customerEmailIdValue = $('#wcs-customerEmailId').val();
            if (customerEmailIdValue !== "") {
                params.email = customerEmailIdValue;
            }
            var customerTelephoneNumberValue = $('#wcs-customerTelephoneNumber').val();
            if (customerTelephoneNumberValue !== "") {
                params.mobile_number = customerTelephoneNumberValue;
            }
        }
        params.isMobileExist = $('#isMobileExist').val();
        params.storeId = $('#storeId').val() || $('#shp_storeId').val();
        params.catalogId = $('#catalogId').val();
        params.langId = $('#langId').val();
        var error = null;
        var $contactusForm = $('.wcs-contactus-form');
        var $contactUsSuccess = $('.wcs-contact-us-success');
        var $helpUsOffline = $('.help-us-offline');
        var $helpUsOfflineSuccess = $('.help-us-offline-success');

        $.ajax({
            type: "POST",
            url: "webapp/wcs/stores/servlet/AjaxSendContactUsEmail",
            data: params,
            success: function(result) {
                var json = $.parseJSON(result);
                $(json).each(function(i, val) {
                    $.each(val, function(k, v) {
                        if (k === "errorMessage") {
                            error = v;
                            $('.wcs-note-red p').html(v);
                            $('.delivery-information-note-red').removeClass('wcs-hidden');
                        }
                    });
                });
                if (error === null) {
                    $contactusForm.addClass('wcs-hide');
                    $contactUsSuccess.removeClass('wcs-hide');
                    $helpUsOffline.addClass('wcs-hide');
                    $helpUsOfflineSuccess.removeClass('wcs-hide');
                    Rayban.analytics.needHelpSuccess();
                    Rayban.analytics.contactUsSuccess();
                    sessionStorage.setItem('addressForHelp', 'sended');
                } else {
                    Rayban.analytics.needHelpError("Server error");
                }
            },
            error: function(xhr, ajaxOptions, thrownError) {
                $contactusForm.addClass('wcs-hide');
                $contactUsSuccess.removeClass('wcs-hide');
                $helpUsOffline.addClass('wcs-hide');
                $helpUsOfflineSuccess.removeClass('wcs-hide');
                Rayban.analytics.needHelpError("Server error");
                Rayban.analytics.contactUsError("wcs sendMessageFooterForm footerForm submit - ", xhr.responseText);
            }
        });
    }
}

$(document).ready(function() {
    var $deliveryFiscalCode = $('#WC_DeliveryInfoForm_fiscal_code');
    var $paymentFiscalCode = $('#WC_PaymentInfoForm_fiscal_code');
    $deliveryFiscalCode.keyup(function() {
        var delInfoFC = $deliveryFiscalCode.val();
        $paymentFiscalCode.val(delInfoFC);
    });
    $paymentFiscalCode.keyup(function() {
        var payInfoFC = $paymentFiscalCode.val();
        $deliveryFiscalCode.val(payInfoFC);
    });
});
